import React, { Suspense, lazy, useEffect } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { Spin } from "antd";
import MenuNavbar from "./components/Menu_Navbar";
import Bottom from "./components/Bottom";

// Lazy-loaded Public/User Components
const Dashboard = lazy(() =>
  import("./components/Dashboard_Components/Dashboard")
);
const FakenewsSearch = lazy(() =>
  import("./components/FakenewsSearch_Components/FakenewsSearch_Menu")
);
const FakenewsSearchview = lazy(() =>
  import("./components/FakenewsSearch_Components/FakenewsSearch_View")
);
const News = lazy(() => import("./components/News_Components/News_Menu"));
const Newsview = lazy(() => import("./components/News_Components/News_view"));
const Article = lazy(() =>
  import("./components/Article_Components/Article_Menu")
);
const Articleview = lazy(() =>
  import("./components/Article_Components/Article_view")
);
const MediaShare = lazy(() =>
  import("./components/MediaShare_Components/MdShare_Menu")
);
const MediaShareview = lazy(() =>
  import("./components/MediaShare_Components/MdShare_view")
);
const FakeNewInformation = lazy(() =>
  import("./components/Fninfo_Components/Fninfo_Form")
);
const NotificationHistory = lazy(() =>
  import("./components/Fninfo_Components/Fninfo_History")
);
const Fninfoview = lazy(() =>
  import("./components/Fninfo_Components/Fninfo_View")
);
const Fninfoedit = lazy(() =>
  import("./components/Fninfo_Components/Fninfo_Edit")
);
const Warn = lazy(() => import("./components/Fninfo_Components/Warn"));
const AboutUsView = lazy(() =>
  import("./components/About_Us/About_Us_View")
);

// Lazy-loaded Admin Components
const MDBAdmMenu = lazy(() =>
  import("./components/Admin/Manage_Dashboard_Adm/M_DB_Adm_Menu")
);
const MDBAdmEdit = lazy(() =>
  import("./components/Admin/Manage_Dashboard_Adm/M_DB_Adm_Edit")
);
const ManageInfo = lazy(() =>
  import("./components/Admin/Manage_Info/Adm_Info_Menu")
);
const ManageInfoview = lazy(() =>
  import("./components/Admin/Manage_Info/Adm_Info_View")
);
const AdmInfoCheck = lazy(() =>
  import("./components/Admin/Manage_Info/Adm_Info_Check")
);
const AdmInfoEdit = lazy(() =>
  import("./components/Admin/Manage_Info/Adm_Info_Edit")
);
const ManageFakeInfoMenu = lazy(() =>
  import("./components/Admin/Manage_Fake_Info/Manage_Fake_Info_Menu")
);
const ManageFakeInfoView = lazy(() =>
  import("./components/Admin/Manage_Fake_Info/Manage_Fake_Info_View")
);
const ManageFakeInfoEdit = lazy(() =>
  import("./components/Admin/Manage_Fake_Info/Manage_Fake_Info_Edit")
);
const ManageMembers = lazy(() =>
  import("./components/Admin/Manage_Members/Adm_Mm_Menu")
);
const ManageMembersView = lazy(() =>
  import("./components/Admin/Manage_Members/Adm_Mm_View")
);
const AdmNewsView = lazy(() =>
  import("./components/Admin/ManageContent/Adm_News/Adm_News_view")
);
const AdmArticleView = lazy(() =>
  import("./components/Admin/ManageContent/Adm_Article/Adm_Article_View")
);
const AdmMdShareView = lazy(() =>
  import("./components/Admin/ManageContent/Adm_MdShare/Adm_MdShare_View")
);
const AdmNewsMenu = lazy(() =>
  import("./components/Admin/ManageContent/Adm_News/Adm_News_Menu")
);
const AdmArticleMenu = lazy(() =>
  import("./components/Admin/ManageContent/Adm_Article/Adm_Article_Menu")
);
const AdmMdShareMenu = lazy(() =>
  import("./components/Admin/ManageContent/Adm_MdShare/Adm_MdShare_Menu")
);
const AdmNewsedit = lazy(() =>
  import("./components/Admin/ManageContent/Adm_News/Adm_News_Edit")
);
const AdmArticleedit = lazy(() =>
  import("./components/Admin/ManageContent/Adm_Article/Adm_Article_Edit")
);
const AdmMdShareedit = lazy(() =>
  import("./components/Admin/ManageContent/Adm_MdShare/Adm_MdShare_Edit")
);
const AdmArticleForm = lazy(() =>
  import("./components/Admin/ManageContent/Adm_Article/Adm_Article_Form")
);
const AdmMdShareForm = lazy(() =>
  import("./components/Admin/ManageContent/Adm_MdShare/Adm_MdShare_Form")
);
const AdmNewsForm = lazy(() =>
  import("./components/Admin/ManageContent/Adm_News/Adm_News_Form")
);
const ManageValues = lazy(() =>
  import("./components/Admin/Manage_Values/MV_Routes")
);

// Lazy-loaded User Profile Components
const MenuProfile = lazy(() =>
  import("./components/User_Components/Profile_Menu")
);
const Profile = lazy(() =>
  import("./components/User_Components/Profile_View")
);
const ProfileEdit = lazy(() =>
  import("./components/User_Components/Profile_Edit")
);

const routes = [
  { path: "/", element: <Dashboard /> },

  {
    path: "/FakenewsSearch/FakenewsSearch_view/:id",
    element: <FakenewsSearchview />,
  },
  { path: "/FakenewsSearch", element: <FakenewsSearch /> },

  { path: "/Article_Menu/Article_view/:id", element: <Articleview /> },
  { path: "/Article_Menu", element: <Article /> },

  {
    path: "/MediaShare_Menu/MediaShare_view/:id",
    element: <MediaShareview />,
  },
  { path: "/MediaShare_Menu", element: <MediaShare /> },

  { path: "/News_Menu/News_view/:id", element: <Newsview /> },
  { path: "/News_Menu", element: <News /> },

  { path: "/FakeNews_Menu", element: <FakeNewInformation /> },
  { path: "/FakeNews/NotificationHistory", element: <NotificationHistory /> },
  { path: "/FakeNews/fninfoview/:id", element: <Fninfoview /> },
  { path: "/FakeNews/edit/:id", element: <Fninfoedit /> },
  { path: "/Warn", element: <Warn /> },

  { path: "/About_Us_View", element: <AboutUsView /> },

  { path: "/Admin", element: <MDBAdmMenu /> },
  { path: "/M_DB_Adm_Edit/:id", element: <MDBAdmEdit /> },

  { path: "/Admin/ManageInfo", element: <ManageInfo /> },

  { path: "/Admin/Manage_Fake_Info_Menu", element: <ManageFakeInfoMenu /> },
  {
    path: "/Admin/Manage_Fake_Info_View/:id",
    element: <ManageFakeInfoView />,
  },
  {
    path: "/Admin/Manage_Fake_Info_Edit/:id",
    element: <ManageFakeInfoEdit />,
  },

  {
    path: "/Admin/ManageInfo/ManageInfo_view/:id",
    element: <ManageInfoview />,
  },
  {
    path: "/Admin/ManageInfo/ManageInfo_view/:id/Adm_Info_Check",
    element: <AdmInfoCheck />,
  },
  {
    path: "/Admin/ManageInfo/ManageInfo_edit/:id",
    element: <AdmInfoEdit />,
  },
  { path: "/Admin/ManageMembers", element: <ManageMembers /> },
  {
    path: "/Admin/ManageMembers/ManageMembers_View/:id",
    element: <ManageMembersView />,
  },

  { path: "/Admin/Adm_News_Menu", element: <AdmNewsMenu /> },
  { path: "/Admin/Adm_Article_Menu", element: <AdmArticleMenu /> },
  { path: "/Admin/Adm_MdShare_Menu", element: <AdmMdShareMenu /> },

  { path: "/Admin/Adm_News_edit/:id", element: <AdmNewsedit /> },
  { path: "/Admin/Adm_Article_edit/:id", element: <AdmArticleedit /> },
  { path: "/Admin/Adm_MdShare_edit/:id", element: <AdmMdShareedit /> },

  { path: "/Admin/Adm_News_View/:id", element: <AdmNewsView /> },
  { path: "/Admin/Adm_Article_View/:id", element: <AdmArticleView /> },
  { path: "/Admin/Adm_MdShare_View/:id", element: <AdmMdShareView /> },
  { path: "/Admin/Adm_Article_Form", element: <AdmArticleForm /> },
  { path: "/Admin/Adm_MdShare_Form", element: <AdmMdShareForm /> },
  { path: "/Admin/Adm_News_Form", element: <AdmNewsForm /> },
  { path: "/Admin/ManageValues", element: <ManageValues /> },

  { path: "/User/MenuProfile", element: <MenuProfile /> },
  { path: "/User/Profile", element: <Profile /> },
  { path: "/User/Profile/Edit/:id", element: <ProfileEdit /> },
];

const RouteLoading = () => (
  <div
    style={{
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      minHeight: "50vh",
      gap: "12px",
    }}
  >
    <Spin size="large" />
    <span style={{ color: "#666", fontSize: "16px" }}>กำลังโหลด...</span>
  </div>
);

const AppRoutes = () => {
  // Preload most frequently visited public route chunks during browser idle time
  useEffect(() => {
    if (process.env.NODE_ENV === "test") return;
    import("./components/Dashboard_Components/Dashboard");
    const timer = setTimeout(() => {
      import("./components/News_Components/News_Menu");
      import("./components/News_Components/News_view");
      import("./components/Article_Components/Article_Menu");
      import("./components/Article_Components/Article_view");
      import("./components/MediaShare_Components/MdShare_Menu");
      import("./components/MediaShare_Components/MdShare_view");
    }, 800);
    return () => clearTimeout(timer);
  }, []);

  return (
    <Router>
      <div
        style={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}
      >
        <MenuNavbar />
        <div style={{ flex: 1 }}>
          <Suspense fallback={<RouteLoading />}>
            <Routes>
              {routes.map((route, index) => (
                <Route key={index} {...route} />
              ))}
            </Routes>
          </Suspense>
        </div>
        <Bottom />
      </div>
    </Router>
  );
};

export default AppRoutes;
